/**
 * Mapa centralizado de status de saque (withdrawal).
 * Use getWithdrawalStatusDisplay() em TODOS os componentes que exibem status de saque.
 */
export const WITHDRAWAL_STATUS_MAP = {
  pending: {
    label: 'Aguardando',
    color: '#f59e0b',
    bgColor: '#fef3c7',
    icon: 'fa-clock',
    description: 'Sua solicitação está na fila de processamento.',
  },
  processing: {
    label: 'Processando',
    color: '#3b82f6',
    bgColor: '#dbeafe',
    icon: 'fa-spinner fa-spin',
    description: 'Transferência em andamento. Previsão: até 2 dias úteis.',
  },
  completed: {
    label: 'Concluído',
    color: '#10b981',
    bgColor: '#d1fae5',
    icon: 'fa-circle-check',
    description: 'Valor transferido com sucesso para sua conta.',
  },
  failed: {
    label: 'Falhou',
    color: '#ef4444',
    bgColor: '#fee2e2',
    icon: 'fa-circle-xmark',
    description: 'Não foi possível processar o saque. Entre em contato com o suporte.',
  },
  cancelled: {
    label: 'Cancelado',
    color: '#6b7280',
    bgColor: '#f3f4f6',
    icon: 'fa-ban',
    description: 'Solicitação cancelada.',
  },
};

/**
 * Retorna o objeto de display para um status de saque.
 * @param {string} status
 * @returns {{ label: string, color: string, bgColor: string, icon: string, description: string }}
 */
export function getWithdrawalStatusDisplay(status) {
  return WITHDRAWAL_STATUS_MAP[status] ?? {
    label: 'Desconhecido',
    color: '#6b7280',
    bgColor: '#f3f4f6',
    icon: 'fa-question-circle',
    description: '',
  };
}
